module.exports = __webpack_public_path__ + "static/img/login_face1.177c48c.png";


//////////////////
// WEBPACK FOOTER
// ./static/login/login_face1.png
// module id = qGfA
// module chunks = 83